module.exports = __webpack_public_path__ + "img/rank1.54bc5af0.png";